<template>
  <svg
    id="Group_409"
    data-name="Group 409"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="27.957"
    height="30.085"
    viewBox="0 0 27.957 30.085"
  >
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_348"
          data-name="Rectangle 348"
          class="cls-1"
          width="27.957"
          height="30.085"
        />
      </clipPath>
    </defs>
    <g id="Group_408" data-name="Group 408" clip-path="url(#clip-path)">
      <path
        id="Path_798"
        data-name="Path 798"
        :fill="color"
        d="M27.957,10.641v3.818c-.012.015-.029.028-.034.044A2.068,2.068,0,0,1,25.717,16.3H14.845v-6.2H13.1V16.28c-.076.006-.128.014-.181.014-3.621,0-7.242.008-10.863,0A2.1,2.1,0,0,1,0,14.039c0-.95,0-1.9,0-2.849A2.15,2.15,0,0,1,2.242,8.776H6.5c.093,0,.187-.008.281-.012a8.625,8.625,0,0,0-.793-.468A7.745,7.745,0,0,1,2.91,5.389a3.8,3.8,0,0,1-.53-2.548A3.2,3.2,0,0,1,4.494.3,6.227,6.227,0,0,1,6.888,0,6.251,6.251,0,0,1,10.965,1.5a10.25,10.25,0,0,1,2.89,4.021c.035.08.072.158.1.225.365-.678.682-1.351,1.068-1.976A7.818,7.818,0,0,1,19.258.26,6.893,6.893,0,0,1,21.743.015a5.951,5.951,0,0,1,1.4.19,3.18,3.18,0,0,1,2.39,2.4,3.857,3.857,0,0,1-.64,3.051,7.969,7.969,0,0,1-3.008,2.694c-.236.13-.476.251-.715.375l.014.055h.293c1.446,0,2.893,0,4.34,0a2.08,2.08,0,0,1,2.1,1.76.563.563,0,0,0,.045.1M12.9,8.218a11.25,11.25,0,0,0-1.906-4.152,5.365,5.365,0,0,0-4.6-2.229,3.386,3.386,0,0,0-1.607.4,1.244,1.244,0,0,0-.622,1.591,4.473,4.473,0,0,0,.613,1.161A5.669,5.669,0,0,0,6.51,6.479a11.587,11.587,0,0,0,4.15,1.454c.725.12,1.459.188,2.238.285m2.155-.024c.516-.049.986-.083,1.454-.141a12.8,12.8,0,0,0,4.546-1.361,5.905,5.905,0,0,0,2.485-2.22c.68-1.191.338-2.122-.916-2.465a4.9,4.9,0,0,0-3.767.441c-2.165,1.192-3.107,3.343-3.8,5.746"
        transform="translate(0 0)"
      />
      <path
        id="Path_799"
        data-name="Path 799"
        :fill="color"
        d="M4.211,30.034c-.092-.035-.185-.072-.278-.1a2.119,2.119,0,0,1-1.42-2.011c-.013-3.2-.007-6.4-.007-9.6a1.49,1.49,0,0,1,.022-.183H13.275V30.034Z"
        transform="translate(-0.17 0.051)"
      />
      <path
        id="Path_800"
        data-name="Path 800"
        :fill="color"
        d="M15.932,30.034V18.139H26.7V18.5q0,4.55,0,9.1A2.181,2.181,0,0,1,25.037,30c-.016.005-.027.024-.042.036Z"
        transform="translate(-1.079 0.051)"
      />
    </g>
  </svg>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Reward_Icon",
  props: {
    color: {
      default: "#1C274C",
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
};
</script>

<style>
</style>